module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"AI Finance & Lending","short_name":"AI Finance","description":"Expert mortgage brokers helping Australians secure the best home loans","start_url":"/","background_color":"#0B1C3D","theme_color":"#C8A55A","display":"standalone","icon":"src/images/app-logo.png","icons":[{"src":"src/images/app-logo.png","sizes":"192x192","type":"image/png"},{"src":"src/images/app-logo.png","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"faca9bb83fb4f1864e82f7fc6c5a0ae7"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
